<template>
    <ProfileOptionSelector :model="'marry_plan'" :nextRoute="() => 'IntroduceMyselfPage'" />
</template>

<script>
export default {
    name: 'MarryPlanPage',
}
</script>
